import { Component, type EventEmitter, Prop, h, Event, Listen, State, Element } from '@stencil/core';
import { GenericCardTitle } from '../../../../new-result-cards/generic-subcomponents/generic-card-title/generic-card-title';
import { UiaasSearchLabelList } from '../../../../result-cards/subcomponents/uiaas-search-label-list';
import type { SearchApiDocument } from '../../../../../../api/SearchApi';
import { GenericCardEventsLayer } from '../../../../new-result-cards/generic-subcomponents/generic-card-event-layer/generic-card-event-layer';
import type { SearchProduct } from '../../../../../../api/model/response/documents/public/Product';
import { ResultCardType } from '../../../../new-result-cards/public/product-card/helpers/helpers';
import type { SearchResultClickEvent } from '../../../SearchResultClickEvent';
import {Strategies} from '../../../../../strategies/Strategies';

@Component({
  tag: 'dashboard-company-item',
  shadow: false,
  styleUrl: 'dashboard-company-tile.scss',
})
export class DashboardCompanyItem {
    @Prop() readonly doc: SearchApiDocument;
    @Prop() readonly index: number;
    @Prop() readonly strategies: Strategies;
    @Prop() readonly section: string;
    @Prop() readonly lazyLoadImages: boolean = false;
    @Element() readonly el: HTMLElement;

    @State() accessibilityMode;

    @Event({
      eventName: 'search:ResultCardClick',
      composed: true,
      cancelable: true,
      bubbles: true,
    })
      resultCardClickEventEmitter: EventEmitter<SearchResultClickEvent>;

    @Listen('uiaas:accessibility', { target: 'window' })
    handleAccessibility(ev) {
        this.accessibilityMode = ev.detail;
    }

    connectedCallback() {
        const htmlElement = document.querySelector('html');
        const isAccessibilityOn = htmlElement.classList.contains('se2-accessibility');
        this.accessibilityMode = isAccessibilityOn;
    }

    componentWillLoad() {
        const gridItem = this.el.closest('.grid-item');
        if (gridItem && gridItem.clientWidth > 600) {
          gridItem.classList.add('double');
        }
    }

    render() {
        const accessibilityModeClass = this.accessibilityMode ? '--accessibility' : '';
        return (
          <GenericCardEventsLayer
            clickEmitter={this.resultCardClickEventEmitter}
            doc={this.doc as unknown as SearchProduct}
            index={this.index}
            resutCardType={ResultCardType.Basic}
            section={this.section}
          >
            <div class="document__container result-card__container">
              {/* <a href={this.doc.url} data-card-area={'background'}>
                <section class="result-card__thumbnail-section">
                  <uiaas-thumbnail src={this.doc.thumbnailUrl} custom-lazy-loading={this.lazyLoadImages} />
                </section>
              </a> */}
              <div class='document__content'>
                <a href={this.doc.url} data-card-area={'background'}>
                  <GenericCardTitle
                    url={this.doc.url}
                    text={this.doc.title}
                    strategies={this.strategies}
                  />
                  <div class="document__label-panel">
                    <UiaasSearchLabelList
                      list={[
                        {
                          value: this.doc?.isVideo ? this.doc?.category?.CT_CAT + ' | ' + this.doc?.isVideo : this.doc?.category?.CT_CAT,
                          customValueClass: 'document__category' + accessibilityModeClass,
                        },
                      ]}
                    />
                  </div>
                </a>
              </div>
            </div>
          </GenericCardEventsLayer>
        );
    }
}
